import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { Filter } from '../../../types/Filter';

interface IDeleteResponse {
  success: boolean;
}

export const deleteUserFilter = async (uuid: string): Promise<IDeleteResponse> => {
  const response = await CustomAxios.delete<IDeleteResponse>(`user-filter`, { params: { uuid } });
  const { data } = response;
  return data;
};

export function useDeleteUserFilter() {
  return useMutation({
    mutationFn: (filter: Filter) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserFilters, filter.page] });
      return deleteUserFilter(filter.uuid);
    },
    onSuccess: (_, filter) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserFilters, filter.page] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 404) {
        alert("Filter not found. Please refresh the page.");
      }
    },
  });
}
